import { render, staticRenderFns } from "./ComplaintsFilter.vue?vue&type=template&id=0fccc108"
import script from "./ComplaintsFilter.vue?vue&type=script&lang=js"
export * from "./ComplaintsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports